var VueCookie = require('vue-cookie');
var moment = require('moment');

const state = {
  customers: {

  },
  chartFromDate: undefined,
  chartToDate : undefined,
  chartFromMonth : undefined,
  chartToMonth : undefined,
  chartFromYear : undefined,
  chartToYear : undefined,
  sampling : undefined,
  channels : undefined,
  parameters : undefined,
}

const actions = {
  setChartFromDate({ commit, rootState }, date) {
    // Date format should be "DD/MM/YYYY", also check format for all actions before setting date.
    VueCookie.set('chart-from-date-' + rootState.user.databaseName, date)
    commit('setChartFromDate', date)
  },
  setChartToDate({ commit, rootState }, date) {
    VueCookie.set('chart-to-date-' + rootState.user.databaseName, date)
    commit('setChartToDate', date)
  },
  setChartFromMonth({ commit, rootState }, date) {
    VueCookie.set('chart-from-month-' + rootState.user.databaseName, date)
    commit('setChartFromMonth', date)
  },
  setChartToMonth({ commit, rootState }, date) {
    VueCookie.set('chart-to-month-' + rootState.user.databaseName, date)
    commit('setChartToMonth', date)
  },
  setChartFromYear({ commit, rootState }, date) {
    VueCookie.set('chart-from-year-' + rootState.user.databaseName, date)
    commit('setChartFromYear', date)
  },
  setChartToYear({ commit, rootState }, date) {
    VueCookie.set('chart-to-year-' + rootState.user.databaseName, date)
    commit('setChartToYear', date)
  },
  setSampling({ commit, rootState }, sampling) {
    //localStorage.setItem('chart-sampling', sampling)
    VueCookie.set('chart-sampling-' + rootState.user.databaseName, sampling)
    commit('setSampling', sampling)
  },
  toggleChartChannel({ commit, rootState }, channelCode) {
    // console.log("[Vuex] session/toggleChartChannel", channelCode)
    //let inStore = localStorage.getItem('chart-channels-' + rootState.user.databaseName)
    let inStore = VueCookie.get('chart-channels-' + rootState.user.databaseName)
    if(! inStore)
      inStore = []
    else
      inStore = inStore.split(',')

    if(inStore.includes(channelCode)) {
      let pos = inStore.indexOf(channelCode)
      inStore = inStore.splice(pos, 1)
    } else {
      inStore.push(channelCode)
    }

    //localStorage.setItem('chart-channels', inStore.join(','))
    VueCookie.set('chart-channels-' + rootState.user.databaseName, inStore.join(','))
    commit('setChannels', inStore)
  },
  selectChartChannel({ commit, rootState }, channelCode) {
    //console.log("session/selectChartChannel", channelCode)
    //let inStore = localStorage.getItem('chart-channels-' + rootState.user.databaseName)
    let inStore = VueCookie.get('chart-channels-' + rootState.user.databaseName)
    if(! inStore)
      inStore = []
    else
      inStore = inStore.split(',')

    if(! inStore.includes(channelCode)) {
      inStore.push(channelCode)
    }

    //localStorage.setItem('chart-channels', inStore.join(','))
    VueCookie.set('chart-channels-' + rootState.user.databaseName, inStore.join(','))
    commit('setChannels', inStore)
  },
  deselectChartChannel({ commit, rootState }, channelCode) {
    //console.log("session/deselectChartChannel", channelCode)
    //let inStore = localStorage.getItem('chart-channels-' + rootState.user.databaseName)
    let inStore = VueCookie.get('chart-channels-' + rootState.user.databaseName)
    if(! inStore)
      inStore = []
    else {
      inStore = inStore.split(',')
      inStore = _.filter(inStore, e => e != channelCode)
    }
    VueCookie.set('chart-channels-' + rootState.user.databaseName, inStore.join(','))
    commit('setChannels', inStore)
  },
  toggleChartParameter({ commit }, parameter) {
    let inStore = localStorage.getItem('chart-parameters')
    if(! inStore)
      inStore = []
    else {
      inStore = inStore.split(',')
      inStore = _.filter(inStore, e => e != parameter)
    }

    if(inStore.includes(parameter)) {
      let pos = inStore.indexOf(parameter)
      inStore.splice(pos, 1)
    } else {
      inStore.push(parameter)
    }

    localStorage.setItem('chart-parameters', inStore.join(','))
    commit('setParameters', inStore)
  },
  clear({ commit }) {
    //localStorage.removeItem('parameter')
    //localStorage.removeItem('chart-channels', null)
  }
}

const getters = {
  chartFromDate(state, getters, rootState) {
    if(state.chartFromDate != null) {
      return state.chartFromDate
    }

    let date = VueCookie.get('chart-from-date-' + rootState.user.databaseName)
    if(date)
      return date

    return moment().subtract(30, 'days').format("DD/MM/YYYY")
  },
  chartToDate(state, getters, rootState) {

    if(state.chartToDate != null) {
      return state.chartToDate
    }

    let date = VueCookie.get('chart-to-date-' + rootState.user.databaseName)
    if(date)
      return date

    return moment().format("DD/MM/YYYY")
  },
  chartFromMonth(state, getters, rootState) {
    if(state.chartFromMonth != null) {
      return state.chartFromMonth
    }

    let date = VueCookie.get('chart-from-month-' + rootState.user.databaseName)
    if(date)
      return date

    return moment().subtract(2, 'months').format("MM/YYYY")
  },
  chartToMonth(state, getters, rootState) {

    if(state.chartToMonth != null) {
      return state.chartToMonth
    }

    let date = VueCookie.get('chart-to-month-' + rootState.user.databaseName)
    if(date)
      return date

    return moment().format("MM/YYYY")
  },
  chartFromYear(state, getters, rootState) {
    if(state.chartFromYear != null) {
      return state.chartFromYear
    }

    let date = VueCookie.get('chart-from-Year-' + rootState.user.databaseName)
    if(date)
      return date

    return moment().subtract(1, 'years').format("YYYY")
  },
  chartToYear(state, getters, rootState) {

    if(state.chartToYear != null) {
      return state.chartToYear
    }

    let date = VueCookie.get('chart-to-Year-' + rootState.user.databaseName)
    if(date)
      return date

    return moment().format("YYYY")
  },
  sampling(state, getters, rootState) {
    if(state.sampling != null) {
      return state.sampling
    }

    //let sampling = localStorage.getItem('chart-sampling-' + rootState.user.databaseName)
    let sampling = VueCookie.get('chart-sampling-' + rootState.user.databaseName)
    if(sampling)
      return sampling

    return 'd'
  },
  channels(state, getters, rootState) {
    if(state.channels != null) {
      return state.channels
    }
    let str = VueCookie.get('chart-channels-' + rootState.user.databaseName)
    if(str)
      return str.split(',')

    return []
  },
  parameters() {
    if(state.parameters != null) {
      return state.parameters
    }
    let str = localStorage.getItem('chart-parameters')
    if(str)
      return str.split(',')

    return []
  },
}

const mutations = {
  setChartFromDate(state, date) {
    state.chartFromDate = date
  },
  setChartToDate(state, date) {
    state.chartToDate = date
  },
  setChartFromMonth(state, date) {
    state.chartFromMonth = date
  },
  setChartToMonth(state, date) {
    state.chartToMonth = date
  },
  setChartFromYear(state, date) {
    state.chartFromYear = date
  },
  setChartToYear(state, date) {
    state.chartToYear = date
  },
  setChannels(state, channels) {
    state.channels = channels
  },
  setParameters(state, parameters) {
    state.parameters = parameters
  },
  setSampling(state, sampling) {
    state.sampling = sampling
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/session.js